<script lang="ts">
	import type { Snippet } from 'svelte';

	interface Props {
		/** Anchor id (used by in-page nav, e.g. "features"). */
		id?: string;
		class?: string;
		children?: Snippet;
	}

	let { id, class: className = '', children }: Props = $props();
</script>

<!-- Standard marketing-page section: centered column, consistent max-width,
     horizontal padding and brand font. Vertical rhythm between sections is
     owned by the page that composes them. -->
<section
	{id}
	class="mx-auto flex w-full max-w-screen-xl flex-col items-center px-5 font-rethink {className}"
>
	{@render children?.()}
</section>
